import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as analyticsIsSupported,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBCfbJY8II5YNvYjS2qdUS29TEF0WAtt94",
  authDomain: "kom-com-27bc4.firebaseapp.com",
  projectId: "kom-com-27bc4",
  storageBucket: "kom-com-27bc4.firebasestorage.app",
  messagingSenderId: "227662964555",
  appId: "1:227662964555:web:a0149e8c577f46d6846ace",
  measurementId: "G-01N6PP1TQH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in supported browser environments
let analytics: ReturnType<typeof getAnalytics> | null = null;
if (typeof window !== "undefined") {
  analyticsIsSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

const db = getFirestore(app);

export { app, db, analytics };
